import { EditOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { Button, Table, Modal, Form, Input, message, Popover, Tooltip, Popconfirm } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { SERVER_ADDRESS } from '../../Config/Config'
import { FaTrash } from 'react-icons/fa'
import './popover.css'
const { TextArea } = Input;

const Faq = () => {
    const [createModal,setCreateModal] = useState(false)
    const [data,setData] = useState([]);
    const [create] = Form.useForm();
    const [edit] = Form.useForm();
    const [editModal,setEditModal] = useState(false)
    const [currentRow,setCurrentRow] = useState(null)
    const userData = JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
    const userPermission = userData.privelege || []

    const fetchfaq = async()=>{
        try {
            const response = await axios.get(`${SERVER_ADDRESS}/api/getFAQ`)
            setData(response.data.data);
        } catch (error) {
            console.log(error)
            message.error({content:"Oops Something went wrong !"})
        }
    }

    const handleAdd = async(values)=>{
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/addFaq`,values)
            if(response.status === 200 && response.data.result === 1){
                message.success({content:`${response.data.message}`})
                fetchfaq()
                handleCreateCancel();
            }
        } catch (error) {
            console.log(error)
            message.error({content:"Oops Something went wrong !"})
        }
    }

    const handleUpdate = async(values)=>{
        const payload = {
            id:currentRow.id,
            question:values.question,
            answer:values.answer
        }
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/editfaq`,payload)
            if(response.status === 200 || response.data.result === 1){
                message.success({content:`${response.data.message}`})
                const updatedData = data.map((item)=>
                    item.id === currentRow.id ? {...item,...values} : item
                )
                setData(updatedData)
                handleEditCancel()
            }
        } catch (error) {
            console.log(error)
            message.error({content:"Oops Something Went Wrong !"})
        }
    }

    const handleDelete = async(id)=>{
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/deletefaq`,{id:id})
            if(response.status === 200 || response.data.result === 1){
                message.success({content:`${response.data.message}`})
                const updatedData = data.filter(item=>item.id !== id)
                setData(updatedData)
                handleEditCancel()
            }
        } catch (error) {
            console.log(error)
            message.error({content:"Oops Something Went Wrong !"})
        }
    }

    useEffect(()=>{
        fetchfaq()
    },[])

    const columns = [
        {
            title:"Id",
            dataIndex:"id",
            key:"id",
            sorter:(a,b)=>a.id-b.id
        },
        {
            title:"Question",
            dataIndex:"question",
            key:"question",
            render: (text) => (
                <Popover content={text} title="Question" trigger="hover">
                  <span style={{textAlign:"center",width:"50%"}} >{text.length > 20 ? `${text.slice(0, 20)}...` : text}</span>
                </Popover>
              ),
        },
        {
            title:"Answer",
            dataIndex:"answer",
            key:"answer",
            render: (text) => (
                <Popover content={text} title="Answer" trigger="hover">
                  <span style={{textAlign:"center",width:"10%"}} >{text.length > 20 ? `${text.slice(0, 20)}...` : text}</span>
                </Popover>
              ),
        },
        {
            title:"Option",
            key:"option",
            render:(_,record)=>(
                <div className='d-flex flex-row gap-3' >
                {userPermission.includes("edit") && (<Tooltip title='Edit FAQ' >
                    <Button variant='filled' color='cyan' onClick={()=>handleEditModal(record)} ><EditOutlined /></Button>
                </Tooltip>) }
                {userPermission.includes("delete") && (
                    <Tooltip title='Delete FAQ' >
                    <Popconfirm title='Are You Sure Want to delete the faq ?' onConfirm={()=>{handleDelete(record.id)}} >
                        <Button variant='filled' color='red' ><FaTrash /></Button>
                    </Popconfirm>
                </Tooltip>
                ) }
                </div>
            )
        },
    ]

    const handleCreateCancel = ()=>{
        setCreateModal(false)
        create.resetFields();
    }

    const handleEditModal = (record)=>{
        setEditModal(true);
        setCurrentRow(record)
        edit.setFieldsValue(record)
    }

    const handleEditCancel = ()=>{
        setEditModal(false)
        edit.resetFields();
    }

  return (
    <div style={{marginTop:"4rem"}} >
        <div style={{textAlign:'end'}} >
        {userPermission.includes("create") && (<Button onClick={()=>setCreateModal(true)} className=' text-white' style={{backgroundColor:"#588157",border:"none"}} ><PlusCircleOutlined /> Add FAQ</Button> ) }
        </div>
        <div className='my-5' >
            <Table dataSource={data} columns={columns} rowKey="id" />
        </div>
        <Modal width={'50%'} maskClosable={true} open={createModal} onCancel={()=>handleCreateCancel()} footer={false} title='Add FAQ' >
            <Form onFinish={handleAdd} form={create} >
                <Form.Item name='question' label='Question' rules={[{required:true,message:"Enter Question"}]} >
                    <TextArea showCount maxLength={300} placeholder='Enter Question' />
                </Form.Item>
                <Form.Item name='answer' label='Answer' rules={[{required:true,message:"Enter Answer"}]} >
                    <TextArea showCount maxLength={300} placeholder='Enter Answer' />
                </Form.Item>
                <Form.Item>
                    <Button type='primary' htmlType='submit' >Add</Button>
                </Form.Item>
            </Form>
        </Modal>
        <Modal width={'50%'} maskClosable={true} open={editModal} onCancel={()=>handleEditCancel()} footer={false} title='Edit FAQ' >
            <Form form={edit} onFinish={handleUpdate} >
                <Form.Item name='question' label='Question' rules={[{required:true,message:"Enter Question"}]} >
                    <TextArea showCount maxLength={300} placeholder='Enter Question' label='question' />
                </Form.Item>
                <Form.Item name='answer' label='Answer' rules={[{required:true,message:"Enter Answer"}]} >
                    <TextArea showCount maxLength={300} placeholder='Enter Answer' />
                </Form.Item>
                <Form.Item>
                    <Button type='primary' htmlType='submit' >Update</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>
  )
}

export default Faq